import { Static, Type as T } from '@sinclair/typebox';

export const ImageSchema = T.Object({
  alt: T.String(),
  url: T.String(),
  contentType: T.String(),
});
export type ImageSchema = Static<typeof ImageSchema>;

export const ProductSchema = T.Object({
  productId: T.String(),
  title: T.String(),
  description: T.String(),
  categories: T.Array(T.String()),
  image: T.Optional(ImageSchema),
});
export type ProductSchema = Static<typeof ProductSchema>;
